module.exports = __webpack_public_path__ + "static/img/13.c51740c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/13.png
// module id = 4utg
// module chunks = 1